/**
 * Per-tier media upload limits — mirror of `backend/config/mediaLimits.js`.
 * Used to render the size-cap hint and reject oversized files client-side
 * before they reach the network. Backend is the source of truth; this
 * exists so the UI can show "PRO: up to 25 MB" without an extra fetch.
 */

const MB = 1024 * 1024;

export const VIDEO_SIZE_LIMITS = {
  FREE: 0,
  PRO: 25 * MB,
  PREMIUM: 100 * MB,
  PRO_PLUS: 200 * MB,
  ENTERPRISE: 500 * MB,
};

export const DIGITAL_ASSET_SIZE_LIMITS = {
  FREE: 0,
  PRO: 50 * MB,
  PREMIUM: 200 * MB,
  PRO_PLUS: 500 * MB,
  ENTERPRISE: 2 * 1024 * MB,
};

export const VIDEO_ACCEPT = 'video/mp4,video/webm,video/quicktime,video/mpeg,video/x-msvideo';

export const DIGITAL_ACCEPT = 'application/pdf,application/epub+zip,application/x-mobipocket-ebook,application/zip,application/x-zip-compressed,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.epub,.mobi,.zip,.docx,.doc';

export const videoLimitForTier = (tier = 'FREE') =>
  VIDEO_SIZE_LIMITS[String(tier).toUpperCase()] ?? VIDEO_SIZE_LIMITS.FREE;

export const digitalLimitForTier = (tier = 'FREE') =>
  DIGITAL_ASSET_SIZE_LIMITS[String(tier).toUpperCase()] ?? DIGITAL_ASSET_SIZE_LIMITS.FREE;

export const formatBytes = (bytes) => {
  if (!bytes) return '0 MB';
  const mb = bytes / MB;
  return mb >= 1024 ? `${(mb / 1024).toFixed(1)} GB` : `${Math.round(mb)} MB`;
};
